"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ViewColumn_1 = tslib_1.__importDefault(require("@mui/icons-material/ViewColumn"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const ColumnSelectorPopover_1 = tslib_1.__importDefault(require("./ColumnSelectorPopover"));
/**
 *
 * @category component
 *
 * @description
 * This component is used to render the ColumnSelector. The ColumnSelector has an default useColumnSelector hook that is optional to use.
 *
 * @example
 * In the following example we implement and use the columnSelector together with an TableSimple table.
 * ```tsx
 * type TcolumnId = "aplha" ;
    //The ColmnSelector needs the columns titles record to resolve the display name. This should be Internationalized.
    const columnsTitles: Record<TcolumnId, string> = {
    aplha: "Alpha option",
      };

//The Columns should be of TTableSimpleHeaders type and correspond with a table.
  const exampleColumns: TTableSimpleHeaders<TcolumnId>[] = [
    {
      columnId: "aplha",
      kind: "text-header",
      text: "Alpha",
      hidden: false,
    }];
 *
 * //The useColumnSelector hook only has to required props, but has functionality to override all text displayed in popover.
 *   const selectorProps: IUseColumnSelectorProps<TcolumnId> = {
    columns: exampleColumns,
    columnsTitles,
  };
 *
  const columnSelectorProps = useColumnSelector({
    ...selectorProps,
  });
 *
  //Convert columns of type IColumnListItem[] -> TTableSimpleHeaders<TcolumnId>[]
  const convertedHeaders = columnSelectorProps.columns
    .filter((item) => item.checked === true) // only return visible columns
    .map((item) => {
      const column = exampleColumns.find((col) => col.columnId === item.columnId);
      return column;
    });

 * return (
    <>
      <ColumnSelectorButton {...columnSelectorProps} />
      <TableSimple headers={{ columns: convertedHeaders as TTableSimpleHeaders<TcolumnId>[] }} rows={[]} />
    </>
  );
 *
 *
 * ```
 *
 */
const SimpleTableColumnSelector = (props) => {
    const { tooltipProps, setAnchorEl, handleOpenPopover, open, anchorEl, ...rest } = props;
    const onClose = () => {
        handleOpenPopover(false);
        setAnchorEl(null);
    };
    const onClick = (e) => {
        e.preventDefault();
        handleOpenPopover(!open);
        setAnchorEl(e.currentTarget);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Tooltip_1.default, { ...tooltipProps },
            react_1.default.createElement(IconButton_1.default, { id: "tableColumns", size: "large", onClick: onClick },
                react_1.default.createElement(ViewColumn_1.default, null))),
        open && react_1.default.createElement(ColumnSelectorPopover_1.default, { anchorEl: anchorEl, onClose: onClose, open: open, ...rest })));
};
exports.default = SimpleTableColumnSelector;
